import React from "react";
import backgroundImage from "../assets/img/impact-image.png";
// import backgroundImageheader from "../assets/img/volunteerheader.png";
import curve from "../assets/icons/curvyline.svg"; // Example icon 1
import { Link } from "react-router-dom";
import SEO from "./SEO";
import { useEffect } from "react";
import ReactGA  from "react-ga4";

const Impact = () => {
	useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/impact",
      title: "Our Impact | SynergyCare Foundation",
    });
  });
	return (
		<section className='font-sans'>
			<SEO
				title='Our Impact | SynergyCare Foundation '
				description='See how SynergyCare Foundation is transforming lives by connecting under-served populations to healthcare.'
				name='SynergyCare Foundation'
				type=''
			/>
			<div className='bg-[#F6FEFA]'>
				<div className='text-center space-y-2 md:pt-40 pt-32 pb-16 w-[90%] max-w-[1440px] mx-auto text-[#002814]'>
					<h1 className='md:text-[72px]/[79px] text-[40px]/[49px] lg:tracking-[-2px] tracking-[-1.72px] font-medium'>
						Making a difference
						<br />
						Together
					</h1>
					<img
						src={curve}
						alt='Icon 1'
						className='absolute lg:top-40 lg:right-20 top-0 right-0'
					/>

					{/* Paragraph Section */}
					<p className='max-w-[771px] w-full mx-auto  md:text-xl/[30px] text-xs/[21px]'>
						At SynergyCare Foundation, our work directly impacts lives. We
						measure our success by the stories of hope and transformation that
						come from the communities we serve. Here are some highlights
					</p>
				</div>
			</div>

			<div className='w-[90%] max-w-[1440px] mx-auto py-16'>
				<div
					style={{
						backgroundImage: `url(${backgroundImage})`,
						backgroundSize: "cover",
						backgroundPosition: "center",
						backgroundRepeat: "no-repeat",
					}}
					className=' rounded-[20px] xl:h-[648px] lg:pb-20 py-14 xl:pt-0 bg-fixed'>
					<div className='flex gap-5 justify-center lg:items-end lg:flex-row  flex-wrap w-[100%] h-full mb-0'>
						<div className='text-[#025788] bg-[#FFCF4E] rounded-[20px] p-5 border-[3px] border-[#FFCF4E] space-y-4 lg:w-[350px] sm:w-[300px] w-[90%] lg:h-[305px] '>
							<p className='md:text-[32px]/[42px] text-xl/7 font-semibold pr-6'>
								Patients Connected
							</p>
							<p className='md:text-2xl/8 text-sm/5'>
								Thousands of under-served individuals have been matched with the
								healthcare providers they need.
							</p>
						</div>
						<div className='text-[#FFFFFF] bg-transparent rounded-[20px] p-5 border-[3px] border-white space-y-4 lg:w-[350px] sm:w-[300px] w-[90%] lg:h-[305px] '>
							<p className='md:text-[32px]/[42px] text-xl/7 font-semibold'>
								Communities Empowered
							</p>
							<p className='md:text-2xl/8 text-sm/5'>
								Our outreach programs have reached over 10,000 people, providing
								them with knowledge to take control of their health.
							</p>
						</div>
						<div className='text-[#FFFFFF] bg-transparent rounded-[20px] pt-5 pl-5 pb-5 border-[3px] border-white space-y-4 lg:w-[350px] sm:w-[300px] w-[90%] lg:h-[305px]'>
							<p className='md:text-[32px]/[42px] text-xl/7 font-semibold'>
								Healthcare Providers Supported
							</p>
							<p className='md:text-2xl/8 text-sm/5'>
								We’ve built a network of dedicated providers who share our
								mission of equitable care.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div className='bg-[#E4FFF2]'>
				<div className='py-16 w-[90%] max-w-[1440px] mx-auto lg:space-y-8 space-y-4 text-center'>
					<h1 className='md:text-[64px]/[76px] text-2xl/10 font-medium text-[#11112D] mb-4'>
						Your Role in Our Impact
					</h1>

					{/* Paragraph Section */}
					<p className='max-w-4xl mx-auto w-full text-center text-xs/5 md:text-2xl/10 text-[#11112d] font-normal mb-8'>
						Every donation, volunteer effort, and partnership amplifies our
						ability to create lasting change. Join us in making healthcare
						accessible for all.
					</p>
					<div className='flex flex-col items-center justify-center py-4 sm:flex-row gap-4'>
						{/* Link to /donate */}
						<Link
							to='/get-started'
							className='text-black text-base bg-[#22E27F] px-6 py-3 rounded-full sm:w-fit w-full text-center'>
							Get Started
						</Link>
						{/* Link to /volunteer */}
						<Link
							to='/volunteer'
							className='text-[#22E27F] text-base bg-transparent px-6 py-3 rounded-full border-[#373E3B] border sm:w-fit w-full text-center'>
							Volunteer
						</Link>
						<Link
							to='/donate'
							className='text-[#22E27F] text-base bg-transparent px-6 py-3 rounded-full border-[#373E3B] border sm:w-fit w-full text-center'>
							Donate Now
						</Link>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Impact;
